/**
 * @generated SignedSource<<7f41f2dc6513f94356c4d033c6f953c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateOauthVerificationKeyInput = {
  clientId?: string | null;
  redirectUri?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createOauthVerificationKeyMutation$variables = {
  input: CreateOauthVerificationKeyInput;
};
export type createOauthVerificationKeyMutation$data = {
  readonly createOauthVerificationKey: {
    readonly code: string | null;
  } | null;
};
export type createOauthVerificationKeyMutation = {
  variables: createOauthVerificationKeyMutation$variables;
  response: createOauthVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOauthVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createOauthVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createOauthVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createOauthVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7f2a9a17a8b71f66d8033b3f57b03493",
    "id": null,
    "metadata": {},
    "name": "createOauthVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createOauthVerificationKeyMutation(\n  $input: CreateOauthVerificationKeyInput!\n) {\n  createOauthVerificationKey(input: $input) {\n    code\n  }\n}\n"
  }
};
})();

(node as any).hash = "389c735c26110d6465a7479ef7661bcf";

export default node;
